import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row mb-4" }
const _hoisted_2 = { class: "col-md-6 col-lg-6 col-xl-6 col-xxl-6" }
const _hoisted_3 = { class: "col-auto flex-grow-1 flex-shrink-1" }
const _hoisted_4 = { class: "col-auto flex-grow-1 flex-shrink-1" }
const _hoisted_5 = {
  key: 0,
  class: "col-auto flex-grow-0 flex-shrink-0"
}
const _hoisted_6 = { class: "mb-3" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label d-block",
  style: {"color":"#fff"}
}, ".", -1)
const _hoisted_8 = { class: "row mb-4" }
const _hoisted_9 = { class: "col-12" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-12 text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader_ui = _resolveComponent("loader-ui")!
  const _component_select_ui = _resolveComponent("select-ui")!
  const _component_form_group_ui = _resolveComponent("form-group-ui")!
  const _component_input_ui = _resolveComponent("input-ui")!
  const _component_button_ui = _resolveComponent("button-ui")!
  const _component_modal_ui = _resolveComponent("modal-ui")!

  return (_openBlock(), _createBlock(_component_modal_ui, {
    id: _ctx.id,
    size: "modal-md",
    title: _ctx.state.title
  }, {
    default: _withCtx(() => [
      _createElementVNode("form", {
        class: "loader",
        onSubmit: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.send && _ctx.send(...args)), ["prevent"]))
      }, [
        _createVNode(_component_loader_ui, {
          "is-show": _ctx.state.loader
        }, null, 8, ["is-show"]),
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_form_group_ui, {
              "invalid-feedback": "Выберите сотрудника",
              label: "Сотрудник",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_select_ui, {
                  "is-invalid": _ctx.state.visibleErrors && _ctx.isEmployeeIdError,
                  "item-key": "employeeName",
                  options: _ctx.employees,
                  placeholder: "Сотрудник",
                  searchable: true,
                  values: [_ctx.state.employeeId],
                  onOnSelected: _ctx.onEmployeeSelected
                }, null, 8, ["is-invalid", "options", "values", "onOnSelected"])
              ]),
              _: 1
            })
          ])
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.tools, (tool, toolInd) => {
          return (_openBlock(), _createElementBlock("div", {
            key: toolInd,
            class: "row mb-4 border-bottom"
          }, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_form_group_ui, {
                "invalid-feedback": "Выберите инструмент",
                label: "Инструмент",
                required: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_select_ui, {
                    "is-invalid": _ctx.state.visibleErrors && _ctx.isToolIdError(tool),
                    "item-key": "name",
                    options: _ctx.tools,
                    placeholder: "Инструмент",
                    searchable: true,
                    values: [tool.id],
                    onOnSelected: (v) => _ctx.onToolSelected(tool, v)
                  }, null, 8, ["is-invalid", "options", "values", "onOnSelected"])
                ]),
                _: 2
              }, 1024)
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_form_group_ui, {
                "invalid-feedback": "Укажите количество",
                label: "Количество",
                required: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_input_ui, {
                    modelValue: tool.count,
                    "onUpdate:modelValue": ($event: any) => ((tool.count) = $event),
                    "is-invalid": _ctx.state.visibleErrors && _ctx.isCountError(tool),
                    mask: { mask: 'Z*', tokens: { 'Z': { pattern: /[0-9]/ }}},
                    placeholder: "Количество"
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "is-invalid"])
                ]),
                _: 2
              }, 1024)
            ]),
            (_ctx.state.tools.length > 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _hoisted_7,
                    _createVNode(_component_button_ui, {
                      class: "btn-outline-danger",
                      type: "button",
                      onClick: ($event: any) => (_ctx.deleteTool(toolInd))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" x ")
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
        }), 128)),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_button_ui, {
              class: "btn-outline-secondary",
              type: "button",
              onClick: _ctx.addTool
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Добавить инструмент ")
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_button_ui, { "button-class": "btn-primary" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.state.btn), 1)
              ]),
              _: 1
            })
          ])
        ])
      ], 32)
    ]),
    _: 1
  }, 8, ["id", "title"]))
}